<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Sidopanel
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Kortpanel med numrerade nyckelpunkter. Visas i sidocolumnen på
      tekniksidor.
    </p>

    <PreviewFull label="Takeaway-panel">
      <div
        class="w-full rounded-[20px] p-6"
        style="border: 1px solid rgba(20, 184, 166, 0.2)"
      >
        <h3
          class="font-[Poppins] font-bold text-[15px] text-[#191c1e] mb-4 m-0"
        >
          Kom ihåg
        </h3>
        <ul class="m-0 p-0 list-none flex flex-col gap-3">
          <li
            v-for="(item, i) in takeaways"
            :key="i"
            class="flex items-start gap-3"
          >
            <span
              class="flex-shrink-0 w-6 h-6 rounded-full bg-teal-500 flex items-center justify-center font-[Poppins] font-bold text-[11px] text-white"
              >{{ i + 1 }}</span
            >
            <span
              class="font-[Plus_Jakarta_Sans] text-[14px] text-[#3c4947] leading-[1.55] pt-0.5"
              >{{ item }}</span
            >
          </li>
        </ul>
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div class="w-full rounded-[20px] p-6" style="border: 1px solid rgba(20,184,166,0.2)">
  <h3 class="font-[Poppins] font-bold text-[15px] text-[#191c1e] mb-4 m-0">Kom ihåg</h3>
  <ul class="m-0 p-0 list-none flex flex-col gap-3">
    <li v-for="(item, i) in takeaways" :key="i" class="flex items-start gap-3">
      <span class="flex-shrink-0 w-6 h-6 rounded-full bg-teal-500 flex items-center justify-center
                   font-[Poppins] font-bold text-[11px] text-white">
        {{ i + 1 }}
      </span>
      <span class="font-[Plus_Jakarta_Sans] text-[14px] text-[#3c4947] leading-[1.55] pt-0.5">
        {{ item }}
      </span>
    </li>
  </ul>
</div>`;

const cssCode = `/* Kort-container */
border-radius: 20px;
border: 1px solid rgba(20,184,166,0.2);
padding: 24px;  /* p-6 */

/* Nummercikel */
width: 24px;    /* w-6 */
height: 24px;   /* h-6 */
border-radius: 9999px;
background: #14b8a6;  /* bg-teal-500 */

/* Nummer-font */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 11px;
color: white;

/* Punkt-text */
font-family: 'Plus Jakarta Sans', sans-serif;
font-size: 14px;
color: #3c4947;
line-height: 1.55;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];

const takeaways = [
  "Autolys förbättrar glutenstrukturen utan extra knådning",
  "Vänta minst 20 minuter för att se tydlig skillnad",
  "Tillsätt salt efter autolysfasen för bästa resultat",
  "Fungerar bäst med stenmalet fullkornsmjöl",
];
</script>
